class TableRow {
  constructor () {
    this.row = new Array();
  }

  push (col) {
    let colOpt = col.getColOptions();
    this.row.push(colOpt);
  }

  _cols () {
    return this.row;
  }
}

class TableColumns {
  constructor () {
    this.columnOptions = new Object();
  }

  getColOptions () {
    return this.columnOptions;
  }

  _data (data) {
    this.columnOptions.indexID = data;
    this.columnOptions.prop = data;
    return this;
  }

  _title (title) {
    this.columnOptions.title = title;
    return this;
  }

  _titleHelp (option) {
    this.columnOptions.titleHelp = Object.assign({}, option);
    return this;
  }

  _headerClassName (className) {
    this.columnOptions.headerClassName = className;
    return this;
  }

  _field (field) {
    this.columnOptions.field = field;
    return this;
  }

  _width (width) {
    this.columnOptions.width = width;
    return this;
  }

  _align (align) {
    this.columnOptions.align = align;
    return this;
  }

  /**
   * @method _fixed: 固定列
   * @param fixed {String}: left || right
   */
  _fixed (fixed) {
    this.columnOptions.fixed = fixed;
    return this;
  }

  /**
   * @method _others: 列的类型
   * @param type {String}: seq(序号) || checkbox || radio
   */
  _others (type) {
    this.columnOptions.type = type;
    return this;
  }

  /**
   * @method _offOverFlow: 表格是否显示全文
   * @param val {Boolean}: 默认false 超出单元格，以折行显示。 true以省略号显示
   */
  _offOverFlow (val) {
    this.columnOptions.offOverFlow = val;
    return this;
  }

  /**
   * @method _headerOffOverFlow: 表头是否显示全文
   * @param val {Boolean}: 默认false 超出单元格，以折行显示。 true以省略号显示
   */
  _headerOffOverFlow (val) {
    this.columnOptions.headerOffOverFlow = val;
    return this;
  }

  /**
   * @method _cellType: 自定义渲染器Name   customDom (@/common/vxeTableConfigure.js)
   * @param type {String}: customDom
   */
  _cellType (type) {
    let cellOpt = new Object();
    cellOpt['name'] = type;
    this.columnOptions.cellRender = cellOpt;
    return this;
  }

  /**
   * @method _cellData: 自定义渲染器render片段  配合_cellType使用
   * @param option {Object}: {formater:({ row, column })=>{return ()}}
   */
  _cellData (option) {
    try {
      Object.assign(this.columnOptions.cellRender, option);
    } catch (err) {
      alert('请先调用方法 _cellType(<String>) 设置单元格类型!');
    }
    return this;
  }

  /**
   * @method _editType: 可编辑单元格类型
   * @param type {String}: 仅支持editTypes里的
   */
  _editType (type = 'input') {
    let editTypes = [
      'editSelect',
      'inputNumber',
      'ElSelect',
      'input',
      'textarea',
      'select',
      'editDialog',
      'ElInputNumber',
      'ElDatePicker',
      'ElTimeSelect'
    ];
    if (editTypes.includes(type)) {
      let editObj = new Object();
      editObj['name'] = type;
      this.columnOptions.editRender = editObj;
      return this;
    } else {
      alert('请正确填写编辑类型参数！');
    }
  }

  /**
   * @method _editData: 可编辑单元格额外参数
   * @param option {Object}:
   * 比如_editType类型为select
   * Object:{
   *   options:[],
   *   optionProps:{
   *     value,
   *     label
   *   },
   *   events:{
   *     change: ({ row }) => {}
   *   }
   * }
   */
  _editData (option) {
    try {
      Object.assign(this.columnOptions.editRender, option);
      return this;
    } catch (err) {
      alert('请先调用方法 _editType(<String>) 设置编辑类型!');
    }
  }

  /**
   * @method _children: 多级表头
   * @param optArr {Array}: [{data,title,width,fixed,offOverFlow,editable,editType,cellType}]
   */
  _children (optArr) { // 多级表头
    let arrMap = {
      data: 'prop',
      title: 'label',
      width: 'width',
      fixed: 'fixed',
      offOverFlow: 'offOverFlow',
      editable: 'editable',
      editType: 'name',
      cellType: 'name'
    };
    let children = [];
    optArr.forEach(item => {
      let itemMap = {};
      for (let i in item) {
        let val = item[i];
        let key = arrMap[i];
        if (key) {
          itemMap[key] = val;

          // //自定义渲染处理
          // if(i === "cellType"){

          // }
          // //可编辑处理
          // if(i === "editType"){

          // }
          // //自定义渲染_render片段处理
          // if(i === "cellData"){

          // }
          // //可编辑_参数处理
          // if(i === "editType"){

          // }
        }
      }
      itemMap['indexID'] = item['data'];
      children.push(itemMap);
    });
    this.columnOptions.children = children;
    return this;
  }
}

export { TableRow, TableColumns };
